// extracted by mini-css-extract-plugin
module.exports = {"two-column-list":"OwnerReviews_two-column-list__8ifud"};